<template>
	<div>
		<div class="data4">
			<div class="data4Til">
				{{list.data.menuTitle}}
			</div>
			<div class="data4Swiper">
				<div class="swiper-data4-banner" :class="`swiper-data4-banner${list.index}`" >
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in list.data.videos" :key="index">
							<!-- <video :src="item" :autoplay="true" muted loop></video> -->
							<template v-if="headerShow">
									<video :src="item" :autoplay="true" muted loop webkit-playsinline playsinline x5-video-player-type="h5-page"></video>
								</template>
								<template v-else>
									<video :src="item"  muted loop webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto" :poster="item+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
								</template>
							<!-- <img :src="item.img" />
							<div class="swiper-slide-dw" :class="activeIndex==index?' ':''"
								style="animation-duration: 1s;">
								<div class="swiper-slide-dw-name">{{item.title}}</div>
								<div class="swiper-slide-dw-cen">
									<div v-for="(itema,indexa) in item.desc" :key="indexa">
										{{itema.text}}
									</div>
								</div>
								<div class="swiper-slide-dw-cenen">{{item.cenEn}}</div>
							</div> -->
						</div>
					</div>
					<template v-if="!headerShow">
						<div class="swiper-hexin-prev"  :style="{
							left:`30px`,
							display:qhShow?activeIndex==0?'none':'block':'none'
						}" @click="prev()">
							<img src="@/assets/index/hxz.png" />
						</div>
						<div class="swiper-hexin-next" :style="{
							right:`30px`,
							display:qhShow?activeIndex==list.data.videos.length-1?'none':'block':'none'
						}" @click="next()">
							<img src="@/assets/index/hxy.png" />
						</div>
					</template>
				</div>
			</div>
			<div class="data2RightBox">
				<div class="data2RightBoxFor" v-for="(item,index) in list.data.content" :key="index">
					<div class="data2RightBoxForImg">
						<img :src="item.icon" />
					</div>
					<div class="data2RightBoxForName">
						{{item.title}}
					</div>
					<div class="data2RightBoxForCen">
						<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props:{
			list:{
				typeof:Object,
				default:{}
			}
		},
		data() {
			return {
				activeIndex: 0,
				// list: [{
				// 		img: require('@/assets/product/njysddlzs.png'),
				// 	},
				// 	{
				// 		img: require('@/assets/product/njysddlzs.png'),
				// 	}
				// ],
				njgfList: [{
						img: require('@/assets/product/data1/ksgl.png'),
						name: '科室管理',
						cen: '评分可视化呈现，帮助科室管理及评估- 为团队提高诊疗水平提供辅助平台'
					},
					{
						img: require('@/assets/product/data1/zdlt.png'),
						name: '临床图库',
						cen: '- 支持各部位临床图参考- 进一步提升医者的诊疗素养'
					},
					{
						img: require('@/assets/product/data1/czpf.png'),
						name: '操作评分',
						cen: '- 统计各部位用时情况，根据视野完成度评分- 便于进行针对性提升'
					},
				],
				qhShow:true,
			}
		},
		mounted() {
			let t = this;
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false,
			// },
			let name='.swiper-data4-banner'+this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay:false,
				allowTouchMove: this.list.data.videos.length > 1 ? true : false,
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},

				},
			});
			this.$nextTick(function(){
				if(this.list.data.videos.length<2){
					this.qhShow=false
				}
			})
		},
		methods: {
			next(){
				console.log("right")
				let t=this;
				if(t.activeIndex==t.list.data.videos.length-1){
					t.activeIndex = 0;
				}else{
					t.activeIndex++;
				}
				// this.mySwiper.slideNext()
			},
			prev(){
				let t=this;
				if(t.activeIndex==0){
					t.activeIndex = t.list.data.videos.length-1;
				}else{
					t.activeIndex--;
				}
				console.log("left")
				// this.mySwiper.slidePrev()
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.swiper-data4-banner {
		overflow: hidden;
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
	}

	.swiper-slide {
		position: relative;

		img {
			width: 100%;
			height: 600px;
			object-fit: cover;
		}

		video {
			width: 100%;
			height: 600px;
			object-fit: cover;
		}
	}

	.data2RightBox {
		display: flex;
		// align-items: center;
		flex-wrap: wrap;
		width: 100%;
		.data2RightBoxFor:not(:last-child) {
			margin-right: 120px;
		}

		.data2RightBoxFor {
			width: 243px;
			margin-bottom: 58px;

			.data2RightBoxForImg {
				margin-bottom:  35px;

				img {
					width: 70px;
					height: 70px;
				}
			}

			.data2RightBoxForName {
				font-size: 26px;
				
				font-weight: 400;
				color: #000000;
				margin-bottom:  35px;
			}

			.data2RightBoxForCen {
				font-size: 18px;
				
				font-weight: 300;
				color: #000000;
				>div{
					white-space: pre-line;
				}
			}
		}
	}
	.data4{
		padding-bottom: 150px;
		width: 1200px;
		margin: 0 auto;
		.data4Til{
			font-size: 45px;
			
			font-weight: bold;
			color: #000000;
			margin-bottom: 67px;
		}
		.data4Swiper{
			width: 100%;
			margin-bottom: 38px;
		}
	}
	@media screen and (max-width:1200px) {
			.swiper-slide {
			
				img {
					height: auto !important;
					object-fit: contain !important;
				}
			
				video {
					width: 100%;
					height: auto !important;
					object-fit: contain !important;
				}
			}
			
			.data2RightBox {
				.data2RightBoxFor:not(:last-child) {
					margin-right: 0px !important;
				}
				.data2RightBoxFor:nth-of-type(2n-1) {
					margin-right: 20px !important;
				}
				.data2RightBoxFor {
					width: calc(50% - 10px);
					margin-bottom: 20px !important;
			
					.data2RightBoxForImg {
						margin-bottom:  20px !important;
			
						img {
							width: 35px !important;
							height: 35px !important;
						}
					}
			
					.data2RightBoxForName {
						font-size: 18px !important;
						margin-bottom:  20px !important;
					}
			
					.data2RightBoxForCen {
						font-size: 14px !important;
					}
				}
			}
			.data4{
				padding:0 30px 30px !important;
				width: 100% !important;
				box-sizing: border-box;
				.data4Til{
					font-size: 24px !important;
					margin-bottom: 20px !important;
				}
				.data4Swiper{
					margin-bottom: 20px !important;
				}
			}
			.swiper-data4-banner{
				.swiper-hexin-prev{
					display: block;
				}
				.swiper-hexin-next{
					display: block;
				}
				.swiper-hexin-prev {
					position: absolute;
					top: 50%;
					left: 250px;
					z-index: 99;
					width: 48px;
					height: 48px;
					cursor: pointer;
					img {
						width: 14px !important;
						height: 24px !important;
					}
				
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 100%;
					transform: translateY(-50%);
					transition: all 0.3s ease;
				}
				
				.swiper-hexin-next {
					transform: translateY(-50%);
					position: absolute;
					top: 50%;
					right: 250px;
					z-index: 99;
					width: 48px;
					height: 48px;
					border-radius: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					transition: all 0.3s ease;
					cursor: pointer;
					img {
						width: 14px !important;
						height: 24px !important;
					}
				}
			}
		}
</style>